import React from 'react';
import { withRouter } from "react-router-dom";
import { Divider, Icon, LinkText, Typography } from "../../ecosystem";
import ErrorMsg from "./ErrorMsg";
import ProxyXBtn from "./ProxyXBtn";

const ProxyStatus = ({
    errorMsg,
    iconColor,
    link,
    message,
    status,
    circleBtn
}) => {

    return (
        <div className="proxy-home-status">
            <div className="proxy-home-status__heading">
                <div className="proxy-home-status__status">
                    <Icon
                        name='alert'
                        color={iconColor ? iconColor : "$color-primary-b1"}
                    />
                    <Typography
                        type="body-02"
                        color="$color-primary-a2"
                        tag="div"
                        bold
                    >{status}</Typography>
                </div>
                {circleBtn &&
                    <div className="proxy-home-status__button">
                        <ProxyXBtn
                            label={circleBtn.label}
                            onClick={circleBtn.onClick}
                            tooltipId={circleBtn.tooltipId}
                        />
                    </div>
                }
            </div>
            <div className="proxy-home-status__message">
                {message && 
                    <div className="proxy-home-status__main-message">
                        <Typography
                            type="body-01"
                            tag="p"
                        >
                            {message}
                        </Typography>
                        {link &&
                            <LinkText
                                as={<button type="button"></button>}
                                onClick={link.onClick}
                            >
                                {link.label}
                            </LinkText>
                        }
                    </div>
                }

                {errorMsg && typeof errorMsg === 'string' 
                    ? <ErrorMsg
                        message={errorMsg}
                    />
                    : errorMsg
                }
            </div>
            <Divider
                mTop="small"
                mLeft="none"
                mRight="none"
            />
        </div>
        );
}

export default withRouter(ProxyStatus);
